import { Divider } from '@mui/material';
import React, { useState } from 'react';
import {
  Datagrid,
  DateField,
  FunctionField,
  List,
  ListContextProvider,
  NumberField,
  SimpleForm,
  TextField as AdminTextField,
  useListController,
} from 'react-admin';
import { useHistory } from 'react-router';
import { ORDER, ORDER_ITEM } from '../order/Order.string';
import { OrderItem, Supplier } from '../order/Order.type';
import SupplierAutoCompleteInput from '../order/SupplierAutoCompleteInput';
import { toPriceKRW } from '../util/CommonUtils';
import { convToStringFromDateForYearMonth } from '../util/date';
import CommonSettlementDatePicker from './CommonSettlementDatePicker';
import SupplierOrderSettlementShow from './SupplierOrderSettlementShow';

export default function SupplierOrderSettlementList() {
  const listController = useListController({
    resource: 'order-items',
    basePath: 'order-items',
  });

  const history = useHistory();

  const [supplier, setSupplier] = useState<Supplier>();

  const [filter, setFilter] = useState<{
    createdAt?: string;
    supplier?: { id?: number };
  }>({ createdAt: convToStringFromDateForYearMonth(new Date()) });

  const onChangeDate = (value: Date | null | undefined) => {
    setFilter({
      ...filter,
      createdAt: convToStringFromDateForYearMonth(value),
    });
  };
  return (
    <div>
      <Divider sx={{ marginTop: 3 }} />
      <SimpleForm
        style={{ margin: '0 !important', padding: '0 !important' }}
        onSubmit={() => {}}
        toolbar={false}
      >
        <CommonSettlementDatePicker
          value={filter.createdAt}
          onChange={onChangeDate}
        />
        <SupplierAutoCompleteInput
          onSelect={(splr: Supplier) => {
            if (splr.id) {
              setFilter({ ...filter, supplier: { id: splr.id } });
              setSupplier(splr);
            } else {
              let temp = { ...filter };
              delete temp.supplier;
              setFilter(temp);
              setSupplier(undefined);
            }
          }}
        />
      </SimpleForm>
      <SupplierOrderSettlementShow
        date={filter.createdAt}
        supplier={supplier}
      />

      <ListContextProvider value={listController}>
        <List
          hasCreate={false}
          title={`공급사 주문 정산 ${
            supplier?.name ? `: ${supplier?.name}` : ': 전체'
          }`}
          filter={filter}
          basePath={listController.basePath}
          resource={listController.resource}
          perPage={30}
          bulkActionButtons={false}
        >
          <Datagrid
            rowClick={(id, basePath, record) => {
              history.push(`/order-items/${record.id}`);
              return '';
            }}
          >
            <DateField
              cellClassName='react-admin-list-column-100px'
              label={ORDER.CREATED_AT}
              source='createdAt'
            />
            <AdminTextField
              cellClassName='react-admin-list-column-100px'
              label={ORDER_ITEM.ID}
              source='id'
            />
            <AdminTextField
              label={ORDER_ITEM.SUPPLIER_NAME}
              source='supplierName'
            />
            <AdminTextField label={ORDER_ITEM.NAME} source='name' />
            <NumberField
              cellClassName='react-admin-list-column-100px'
              label={ORDER_ITEM.QUANTITY}
              source='quantity'
            />
            <FunctionField
              cellClassName='react-admin-list-column-150px'
              label={ORDER_ITEM.UNIT_PRICE}
              source='unitPrice'
              render={(value: any) => {
                const orderItem: OrderItem = value;
                return toPriceKRW(orderItem.unitPrice);
              }}
            />
          </Datagrid>
        </List>
      </ListContextProvider>
    </div>
  );
}
